export default __webpack_public_path__ + "static/media/handshake.c18657e7.png";